module.exports = __webpack_public_path__ + "img/StridingAI.708978a4.jpg";